import { connect } from 'react-redux';
import { actions as coreActions, selectors as coreSelectors } from 'app-webtech-core';
import { redirect } from 'redux-first-router';
import { WATCH_CHANNEL } from 'app-source/routes/types';
import { ChatSoonComponent } from '../components/ChatSoon';
import * as selectors from '../selectors/index';
import * as actions from '../actions';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state) => {
  const chatChannelId = selectors.getNextChatChannel(state);
  const channel = coreSelectors.linearChannels.fetchById(state)(chatChannelId);
  const currentPlayingContent = coreSelectors.player.content(state);
  const currentChannelId = currentPlayingContent && currentPlayingContent.id;
  return {
    open: selectors.isChatSoonVisible(state) && currentChannelId !== chatChannelId,
    name: (channel && channel.name) || '',
    imgSrc: (channel && channel.featuredImage) || '',
    channelId: (channel && channel._id) || '', // eslint-disable-line no-underscore-dangle
  };
};

const mapDispatchToProps = (dispatch) => ({
  switchToChatChannel: (channelId, slug) => {
    dispatch(redirect({ type: WATCH_CHANNEL, payload: { slug } }));
    dispatch(coreActions.player.loadLinearChannel(channelId));
  },
  hideMe: () => dispatch(actions.hideChatSoon()),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  switchToChatChannel: () => {
    dispatchProps.switchToChatChannel(stateProps.channelId, stateProps.channelSlug);
  },
});

export const ChatSoon = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ChatSoonComponent);
